import {Component, Input, OnInit, ViewChild, ElementRef} from '@angular/core';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-qrcode-card',
  templateUrl: './qrcode-card.component.html',
  styleUrls: ['./qrcode-card.component.scss']
})
export class QrcodeCardComponent implements OnInit {
  @Input() orderId: string;
  @ViewChild('printSection') el: ElementRef;
  qrCodePhrase: string;

  constructor() {

  }

  ngOnInit() {
    this.qrCodePhrase = environment.qrCodeUrlBase + this.orderId;
  }

  printQrCode() {
    const svgQrCode = this.el.nativeElement.firstElementChild.innerHTML;
    const contentToPrint = '<body onload="window.print()" style="max-width:300px">' + svgQrCode + '</body>';
    const newWin = window.frames['printf'];
    newWin.document.write(contentToPrint);
    newWin.document.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/qrcode-card/qrcode-card.component.ts